<template>
  <div class="gb-analysis">
    <div style="width:100%;display: flex;padding:0 10px;font-size: 14px;">
      <div style="flex: 1;font-size: 16px;">
        {{addInfo.name?addInfo.name:"新建报表"}}
        ----
        {{addInfo.user_name?addInfo.user_name:$store.getters.getUserInfo['name']}}
      </div>
      <div style="border-bottom: 1px solid #001529;cursor: pointer" @click="()=>{$router.push('/analysis_report')}">返回列表</div>
    </div>
    <div class="gb-filter-panel">
      <div class="gb-filter-item">
        <div class="gb-filter-label">维度</div>
        <div class="gb-filter-content">
          <div class="gb-select">
            <input v-model="dimensionSearch"
                   :placeholder="dimension.length?'已选中数据：'+dimension.length+'':'请选择维度'" />
            <div v-if="dimension.length" class="gb-select-clear"
                 @click="()=>{dimension=[]}">
              <a-icon type="close" />
            </div>
            <div class="gb-select-list">
              <div v-if="getDimensionList.length===0" style="text-align: center">抱歉！无数据！</div>
              <div class="gb-select-item" @click="checkDimension(dimensionItem)"
                   v-for="dimensionItem in getDimensionList">
                <a-checkbox :checked="dimension.findIndex(_item=>{return _item.code===dimensionItem.code})!==-1"></a-checkbox>
                {{dimensionItem.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gb-filter-item" v-for="conditionItem in conditionList">
        <div class="gb-filter-label">{{conditionItem.name}}</div>
        <div class="gb-filter-content">
          <div class="gb-date" v-if="conditionItem.code==='date'">
            <a-range-picker v-model="filter.date"valueFormat="YYYY-MM-DD"
                            style="width: 200px;height: 100%;" />
          </div>
          <div v-else class="gb-select">
            <input v-model="filterSearch[conditionItem.code]"
                   :placeholder="filter[conditionItem.code].length?'已选中数据：'+filter[conditionItem.code].length+'':'请选择'+conditionItem.name" />
            <div v-if="filter[conditionItem.code].length" class="gb-select-clear"
                 @click="()=>{filter[conditionItem.code]=[]}">
              <a-icon type="close" />
            </div>
            <div class="gb-select-list">
              <div v-if="getFilterDataList(conditionItem.code).length===0" style="text-align: center">抱歉！无数据！</div>
              <div class="gb-select-item" @click="checkFilterAll(conditionItem.code)">
                <a-checkbox :checked="filter[conditionItem.code].length===getFilterDataList(conditionItem.code).length"></a-checkbox>
                全选
              </div>
              <div class="gb-select-item"  @click="checkFilter(conditionItem.code,filterDataItem.value)"
                   v-for="filterDataItem in getFilterDataList(conditionItem.code)">
                <a-checkbox :checked="filter[conditionItem.code].includes(filterDataItem.value)"></a-checkbox>
                {{filterDataItem.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gb-filter-item" v-for="(categoryItem,categoryIndex) in $store.state.report.dataCategory">
        <div class="gb-filter-label">{{categoryItem}}</div>
        <div class="gb-filter-content">
          <div class="gb-select">
            <input v-model="dataFieldSearch[categoryIndex]"
                   :placeholder="dataFieldNum[categoryIndex]?'已选中数据：'+dataFieldNum[categoryIndex]+'':'请选择'+categoryItem" />
            <div class="gb-select-list">
              <div class="gb-select-item" @click="checkFieldAll(categoryIndex)">
                <a-checkbox :checked="dataFieldNum[categoryIndex]===getDataFieldList(categoryIndex).length"></a-checkbox>
                全选
              </div>
              <div class="gb-select-item" @click="checkField(categoryIndex,dataFieldItem)"
                   v-for="dataFieldItem in getDataFieldList(categoryIndex)">
                <a-checkbox :checked="dataField.findIndex(_item=>{return _item.code===dataFieldItem.code})!==-1"></a-checkbox>
                {{dataFieldItem.name}}
              </div>
            </div>
          </div>
          <div class="gb-button size info" @click="addCompose" v-if="categoryIndex==='compose'">
            <a-icon type="plus"></a-icon>
          </div>
        </div>
      </div>
      <div class="gb-filter-item">
        <div class="gb-filter-label"></div>
        <div class="gb-filter-content">
          <a-spin :spinning="dataLoading">
            <div class="gb-button info gb-margin-right"  @click="initDataList">确认</div>
          </a-spin>
          <div class="gb-button info gb-margin-right" @click="downloadReport()">下载</div>
          <div class="gb-button info gb-margin-right" @click="saveReport()">保存</div>
          <div class="gb-button info gb-margin-right" @click="saveReport(true)" v-if="">另存</div>
        </div>
      </div>
    </div>
    <div class="gb-table-panel">
      <div class="gb-table-content">
        <div class="gb-table-list" style="background: #E5E5E5;position: absolute;top:0px;">
          <div class="gb-table-item" v-for="dimensionItem in dimension">
            <div style="display: flex;align-items: center;justify-content: center">
              {{dimensionItem.name}}
              <div style="display: flex;flex-flow: column;font-size: 12px;cursor: pointer">
                <a-icon type="caret-up" :style="{color:getSortStatus(dimensionItem.code,'up')?'#1890ff':'#001529'}" @click="checkSort(dimensionItem.code,'up')"/>
                <a-icon type="caret-down" :style="{color:getSortStatus(dimensionItem.code,'down')?'#1890ff':'#001529'}" @click="checkSort(dimensionItem.code,'down')"/>
              </div>
            </div>
          </div>
          <div class="gb-table-item" v-for="dataItem in dataField">
            <div style="display: flex;align-items: center;justify-content: center">
              {{dataItem.name}}
<!--              <div style="display: flex;flex-flow: column;font-size: 12px;cursor: pointer">-->
<!--                <a-icon type="caret-up" :style="{color:getSortStatus(dataItem.code,'up')?'#1890ff':'#001529'}" @click="checkSort(dataItem.code,'up')"/>-->
<!--                <a-icon type="caret-down" :style="{color:getSortStatus(dataItem.code,'down')?'#1890ff':'#001529'}" @click="checkSort(dataItem.code,'down')"/>-->
<!--              </div>-->
            </div>
          </div>
        </div>
        <div class="gb-table-list" v-for="dataItem in getDataList">
          <div class="gb-table-item" v-for="dimensionItem in dimension">
            {{dataItem[dimensionItem.code]}}
          </div>
          <div class="gb-table-item" v-for="dataFieldItem in dataField">
            {{dataItem[dataFieldItem.code]!==undefined?dataItem[dataFieldItem.code]:'-'}}
          </div>
        </div>
      </div>
    </div>
    <a-modal
      centered
      title="新增组合指标"
      :visible="composeVisible"
      @ok="doAddCompose()"
      @cancel="()=>{composeVisible=false}">
      <a-form-model :model="composeInfo"
                    v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 }}">
        <a-form-model-item label="指标名称" prop="name" style="margin-bottom: 10px">
          <a-input v-model="composeInfo.name" />
        </a-form-model-item>
        <a-form-model-item label="指标描述" prop="desc" style="margin-bottom: 10px">
          <a-input v-model="composeInfo.desc" />
        </a-form-model-item>
        <a-form-model-item label="指标规则" prop="rule" style="margin-bottom: 10px">
          <a-textarea v-model="composeInfo.rule" >
          </a-textarea>
        </a-form-model-item>
      </a-form-model>
      <div style="max-height: 50vh;background: #EEEEEE;padding: 0 5px;border-radius: 5px;overflow-y: scroll">
        <div class="norm-panel"
             v-if="categoryIndex!=='compose'"
             v-for="(categoryItem,categoryIndex) in $store.state.report.dataCategory">
          <div class="norm-panel-label text-no">{{categoryItem}}</div>
          <div style="flex: 1" >
            <div class="norm-panel-item"
                 :class="composeChoice.includes(dataFieldItem.code)?'active':''"
                 @click="choiceComposeNorm(dataFieldItem)"
                 v-for="dataFieldItem in dataFieldList[categoryIndex]">
              {{dataFieldItem.name}}
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      :title="panel_code?'保存看板':'新建看板'"
      :visible="addReportVisible"
      @ok="doSaveReport()"
      @cancel="()=>{addReportVisible=false}"
    >
      <a-form-model :model="addInfo"
                    v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 }}">
        <a-form-model-item label="看板名称" prop="name">
          <a-input v-model="addInfo.name" />
        </a-form-model-item>
        <a-form-model-item label="看板描述" prop="desc">
          <a-input v-model="addInfo.desc"/>
        </a-form-model-item>
        <a-form-model-item label="所有者">
          {{addInfo.user_name?addInfo.user_name:$store.getters.getUserInfo['name']}}
        </a-form-model-item>
        <a-form-model-item label="看板类型" prop="type">
          <a-radio-group v-model="addInfo.type">
            <a-radio :value="typeIndex"
                     :key="typeIndex"
                     v-for="(typeItem,typeIndex) in $store.state.report.panelType">
              {{typeItem}}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {AddNorm, AddPanel, GetAnalysisBase, GetNormList, GetPanel} from "../../api/v1/analysis";

export default {
  name: "Index",
  data(){
    return {
      panel_code:'',
      addReportVisible:false,
      addInfo:{
        type:'public'
      },

      filter:{
        app_id:0,
        date:['',''],
        country:[],
        spend_channel:[],
        revenue_channel:[],
        ad_type:[],
      },
      filterData:{
        country:[],
        spend_channel:[],
        revenue_channel:[],
        ad_type:[],
      },
      filterSearch:{},
      conditionList:[],

      dimension:[],
      dimensionSearch:'',
      dimensionList:[],

      dataFieldSearch:{},
      dataFieldList:{},
      dataField:[],
      dataFieldNum:{},
      dataSuccess:0,
      dataLoading:false,

      downloadField:[],
      dataList:[],

      composeVisible:false,
      composeInfo:{
        rule:'',
        type:'data',
        category:'compose',
      },
      composeChoice:[],

      sort:'',
    }
  },
  watch:{
    getAppId:{
      handler(newName, oldName) {
        if (oldName&&this.dataField.length!==0) this.initDataList()
      },
      immediate: false,
      deep: true
    },
    getCountryList:{
      handler(newName, oldName) {
        this.filterData.country = newName
      },
      immediate: true,
      deep: true
    },
    getSpendChannelList:{
      handler(newName, oldName) {
        this.filterData.spend_channel = newName
      },
      immediate: true,
      deep: true
    },
    getRevenueChannelList:{
      handler(newName, oldName) {
        this.filterData.revenue_channel = newName
      },
      immediate: true,
      deep: true
    },
    getAdTypeList:{
      handler(newName, oldName) {
        this.filterData.ad_type = newName
      },
      immediate: true,
      deep: true
    },
  },
  computed:{
    getDataList(){
      if (this.sort!==''){
        let _sort = this.sort.split('-')
        let _data = JSON.parse(JSON.stringify(this.dataList))
        _data.sort(function (_a,_b){
          return _sort[1]==='down'?_b[_sort[0]].toString().localeCompare(_a[_sort[0]].toString()):_a[_sort[0]].toString().localeCompare(_b[_sort[0]].toString())
        })
        return _data
      }
      return this.dataList
    },
    getAppId(){
      return this.$store.getters.getAppId
    },
    getCountryList(){
      return this.$store.getters.getCountry
    },
    getSpendChannelList(){
      return this.$store.getters.getSpendChannel
    },
    getRevenueChannelList(){
      return this.$store.getters.getRevenueChannel
    },
    getAdTypeList(){
      return this.$store.getters.getAdType
    },
    getDimensionList(){
      return this.dimensionList.filter(item=>{
        return item.name.indexOf(this.dimensionSearch)!==-1
      })
    },
  },
  mounted() {
    this.initPanel()
  },
  methods:{
    initPanel(){
      GetPanel({code:this.$route.query.code}).then(resp => {
        let _type = false
        if (resp.code===200){
          this.panel_code = resp.data.code
          this.addInfo = {
            name:resp.data.name,
            desc:resp.data.desc,
            user_name:resp.data.user_name,
            type:resp.data.type,
            dimension:resp.data.dimension.split(","),
            data:resp.data.data.split(","),
            condition:resp.data.condition.split(","),
            filter:JSON.parse(resp.data.filter)
          }
          _type = true
        }
        this.initNorm(_type)
      })
    },
    initNorm(type=true){
      GetNormList({}).then(resp => {
        if (resp.code===200){
          resp.data.forEach(item => {
            switch (item.type){
              case "dimension":
                this.dimensionList.push(item)
                if (this.addInfo.dimension&&this.addInfo.dimension.includes(item.code)){
                  this.dimension.push(item)
                }
                break
              case "condition":
                this.conditionList.push(item)
                if (this.addInfo.filter&&item.code!=='date'){
                  this.addInfo.filter[item.code].forEach(f_item=>{
                    this.checkFilter(item.code,f_item)
                  })
                }
                break
              case "data":
                if (!this.dataFieldList[item.category])this.dataFieldList[item.category] = []
                this.dataFieldList[item.category].push(item)
                if (this.addInfo.data&&this.addInfo.data.includes(item.code)){
                  this.checkField(item.category,item)
                }
                break;
              default:
                break
            }
          })
          if (type) this.initDataList()
        }
      })
    },
    initDataList(){
      let _dimension = ""
      this.downloadField = []
      this.sort = ''
      this.dimension.forEach(item => {
        if (_dimension) _dimension+=","
        _dimension+=item.code
        this.downloadField.push({
          dataIndex:item.code,
          title:item.name
        })
        // this.sort.push({code:item.code,type:'down'})
      })
      if (!_dimension||this.dataField.length===0) {
        this.$message.error("维度,字段必须选择")
        return
      }
      this.dataList = []
      this.filter.app_id = this.getAppId
      this.dataSuccess = 0
      this.dataLoading = true
      this.dataField.forEach(date_item=>{
        this.downloadField.push({
          dataIndex:date_item.code,
          title:date_item.name
        })
        this.initDataBase(date_item.code,_dimension)
      })
    },
    initDataBase(code,dimension){
      GetAnalysisBase({
        filter:this.filter,
        dimension:dimension,
        data:code}
      ).then(resp => {
        this.dataSuccess+=1
        if (this.dataSuccess===this.dataField.length) this.dataLoading = false
        if (resp.code===200){
          this.filter = resp.data.filter
          resp.data.data.forEach(item=>{
            let _index = this.dataList.findIndex(_item => {
              return _item[dimension]===item[dimension]
            })
            if (_index===-1){
              _index = this.dataList.findIndex(_max_item => {
                return _max_item[dimension]>item[dimension]
              })
              if (_index===-1) _index = this.dataList.length
              this.dataList.splice(_index,0,{key:this.dataList.length})
            }
            Object.assign(this.dataList[_index],item)
          })
        }
      })
    },
    getDataFieldList(code){
      let _search = this.dataFieldSearch[code]
      if (!this.dataFieldList[code]) return []
      return this.dataFieldList[code].filter(item=>{
        return item.name.indexOf(_search)!==-1||!_search
      })
    },
    getFilterDataList(code){
      let _search = this.filterSearch[code]
      return this.filterData[code].filter(item=>{
        return item.name.indexOf(_search)!==-1||!_search
      })
    },
    checkFieldAll(code){
      let _to_check = this.getDataFieldList(code)
      let _clear = this.dataFieldNum[code]===_to_check.length
      _to_check.forEach(_item =>{
        let _index = this.dataField.findIndex(_a_item=>{
          return _a_item.code===_item.code
        })
        if (_clear&&_index!==-1){
          this.dataField.splice(_index,1)
        }
        if (!_clear&&_index===-1){
          this.dataField.push(_item)
        }
      })
      this.dataFieldNum[code] = _clear?0:_to_check.length
    },
    checkField(code,item){
      let _index =  this.dataField.findIndex(_item=>{
        return _item.code===item.code
      })
      if (!this.dataFieldNum[code]) this.dataFieldNum[code] = 0
      if (_index===-1){
        this.dataFieldNum[code] += 1
        this.dataField.push(item)
      }else{
        this.dataFieldNum[code] -= 1
        this.dataField.splice(_index,1)
      }
    },
    checkFilterAll(code){
      let _to_check = this.getFilterDataList(code)
      if (this.filter[code].length===_to_check.length){
        this.filter[code]=[]
      }else{
        _to_check.forEach(_item => {
          let _index = this.filter[code].findIndex(_a_item=>{
            return _a_item===_item.value
          })
          if (_index===-1) this.filter[code].push(_item.value)
        })
      }
    },
    checkFilter(code,value){
      let _index =  this.filter[code].findIndex(_item=>{
        return _item===value
      })
      if (_index===-1){
        this.filter[code].push(value)
      }else{
        this.filter[code].splice(_index,1)
      }
    },
    checkDimension(item){
      let _index = this.dimension.findIndex(_item=>{
        return _item.code===item.code
      })
      if (_index===-1){
        this.dimension.push(item)
      }else{
        this.dimension.splice(_index,1)
      }
    },
    downloadReport(){
      let _name = this.$store.getters.getAppInfo.app_name
      _name += "截止："+this._get_current_date(2)+" 的"
      _name += "数据"
      this._export_cvs(this.dataList,this.downloadField,_name)
    },
    saveReport(type = false){
      if (type) this.panel_code = ''
      this.addReportVisible = true
    },
    doSaveReport(){
      this.addInfo.code = this.panel_code
      this.addInfo.condition = []
      this.conditionList.forEach(condition_item => {
        this.addInfo.condition.push(condition_item.code)
      })
      this.addInfo.data = []
      this.dataField.forEach(data_item=>{
        this.addInfo.data.push(data_item.code)
      })
      this.addInfo.dimension = []
      this.dimension.forEach(dimension_item=>{
        this.addInfo.dimension.push(dimension_item.code)
      })
      if (!this.addInfo.dimension||!this.addInfo.data){
        this.$message.error("维度，指标必须！")
        return
      }
      this.addInfo.filter = this.filter
      AddPanel(this.addInfo).then(resp => {
        if (resp.code===200){
          this.addReportVisible = false
          this.$router.push({
            path:'/analysis',
            query:{
              app_id:this.$route.query.app_id,
              code:resp.data
            }
          })
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    addCompose(){
      this.composeVisible = true
      this.composeInfo = {
        rule:'',
        type:'data',
        category:'compose',
      }
    },
    choiceComposeNorm(normItem){
      let _norm_index = this.composeChoice.indexOf(normItem.code)
      if (_norm_index===-1){
        this.composeInfo.rule += '['+normItem.name+']'
        this.composeChoice.push(normItem.code)
      }else{
        this.composeInfo.rule = this.composeInfo.rule.replace(normItem.name,'')
        this.composeInfo.rule = this.composeInfo.rule.replace('[]','')
        this.composeChoice.splice(_norm_index,1)
      }
    },
    doAddCompose(){
      AddNorm(this.composeInfo).then(resp => {
        if (resp.code===200){
          this.composeVisible = false
          this.composeChoice = []
          this.composeInfo = {
            rule:'',
            type:'data',
            category:'compose',
          }
          this.dataFieldList['compose'].push(resp.data)
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    getSortStatus(code,type){
      return this.sort === code+'-'+type
    },
    checkSort(code,type,refresh = true){
      let _sort = code+'-'+type
      this.sort = this.sort===_sort?'':_sort
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Analysis/Index.vue